// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__E_5oy","modalForm":"UpgradeEpcsModal_modalForm__AS0wn","modalFooter":"UpgradeEpcsModal_modalFooter__gc52M"};